/*
 * @Author: yongsheng.zhang 
 * @Date: 2017-10-23 17:35:35 
 * @Last Modified by: yongsheng.zhang
 * @Last Modified time: 2017-10-30 10:41:25
 */

/**
 * 读取cookie
 */
const cookie = {
    setCookie: (name, value, expire) => {
        let domain = '';
        if (location.hostname.indexOf('51ping') !== -1) {
            domain = '.51ping.com';
        } else {
            domain = '.dianping.com';
        }
        document.cookie = `${name}=${value};${expire};domain=${domain};path=/`;
    },
    readCookie: (cname) => {
        let name = cname + '=';
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1);
            if (c.indexOf(name) !== -1) return c.substring(name.length, c.length);
        }
        return '';
    },
    clearCookie: (name) => {
        this.setCookie(name, '', -1);
    }
}
module.exports = cookie



// WEBPACK FOOTER //
// ./src/lib/cookie.js